import React from "react";
import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import { Header } from "components";

const InternalTransferContainerScreen = () => {
    return (
        <Layout className="alymente-layout">
            <Header title="Transferência" />
            <Outlet />
        </Layout>
    );
};

export default InternalTransferContainerScreen;
